import React from "react";

export const Membership = () => {
  return (
    <div>
      <section className="lg:pt-[30px] py-[25px]">
        <div className="">
          <div className=" px-5 py-5 ">
            <div className="lg:mb-[80px]  lg:px-10 px-4">
              <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
                Membership Option
              </h3>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center ">
              <div className="flex flex-col text-end pr-10">
                <div className="py-[2rem] max-w-[400px] w-full mx-auto">
                  <h3 className="text-2xl">General Member</h3>
                  <p className="capitalize py-3 leading-8">
                    access as a provider with monitization opportunities
                    included in AI database
                  </p>

                  <button className="bg-[#16E8C5] rounded-full px-[2rem] py-2 text-black font-bold">
                    {" "}
                    $49/mo
                  </button>
                </div>
                <div className="py-[2rem] max-w-[400px] w-full mx-auto">
                  <h3 className="text-2xl">Professional Member </h3>
                  <p className="capitalize py-3 leading-8">
                    Limited Free NFT Minting Included in Al database Represented
                    in Relevant Shops access to ad network
                  </p>

                  <button className="bg-[#CB6BE6] rounded-full px-[2rem] py-2 text-black font-bold">
                    {" "}
                    $99/mo
                  </button>
                </div>
              </div>

              <div>
                <img
                  src={process.env.PUBLIC_URL + "/assets/member.png"}
                  className="w-full mx-auto max-w-[300px]"
                />
              </div>

              <div className="flex flex-col text-end">
                <div className="py-[2rem] max-w-[400px] w-full mx-auto">
                  <h3 className="text-2xl">VIP Member</h3>
                  <p className="capitalize py-3 leading-8">
                    ree NFT Minting Al recomendations Included in Ad Network
                    Inclusive of Specialty Shop
                  </p>

                  <button className="bg-[#910DED] rounded-full px-[2rem] py-2 text-black font-bold">
                    {" "}
                    $199/mo
                  </button>
                </div>
                <div className="py-[2rem] max-w-[400px] w-full mx-auto">
                  <h3 className="text-2xl">Thought Leader Member</h3>
                  <p className="capitalize py-3 leading-8">
                    Unlimited NFT Minting Ulimited Access Priority Al
                    recomendations Priority ads Inclusive of 2 Specialty Shops,
                    Event space, or Office
                  </p>

                  <button className="bg-[#00BCED] rounded-full px-[2rem] py-2 text-black font-bold">
                    {" "}
                    $499/mo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
